import {
  type MutationFunctionOptions,
  type MutationHookOptions,
  type PasswordResetMutation,
  type PasswordResetMutationVariables,
  usePasswordResetMutation,
} from "@qw/graphql";

export function usePasswordReset(
  options: MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables> = {}
) {
  const [passwordResetMutation, result] = usePasswordResetMutation(options);

  const passwordReset = (
    mutationOptions: MutationFunctionOptions<PasswordResetMutation, PasswordResetMutationVariables>
  ) => passwordResetMutation(mutationOptions);

  return [passwordReset, result] as const;
}
